import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthenticationService } from '@app/core';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'app-signup-step-4-modal',
    templateUrl: './signup-modal.template.html',
    styleUrls: [
        './signup-modal.template.scss',
    ],
    animations: []
})
export class SignupStep4ModalComponent implements OnInit, OnDestroy {
    form: FormGroup;
    loading = false;
    errors: string = null;
    success: string = null;

    timer: number = 0;

    verified: boolean = false;
    userInfo$: Subscription;

    verificationState: string = 'pending';

    constructor(
        public auth: AuthenticationService,
        protected renderer: Renderer2,
    ) {
    }

    public ngOnInit() {
      this.timer = 180;
      this.startTimer(this.timer);
      if (this.auth.userInfo) {
        this.update(this.auth.userInfo);
      }
      this.userInfo$ = this.auth.userInfo$.subscribe((user: any) => this.update(user), () => {});
    }

    update(user: any): void {
      if (user) {
        switch (user.verified) {
          case 'true':
            this.verified = true;
            this.verificationState = 'verified';
            break;
          case 'registering':
          case 're-kyc':
            this.verified = false;
            this.verificationState = 'kyc';
            break;
          case 'pending':
            this.verified = false;
            this.verificationState = 'pending';
            break;
          case 'consider':
            this.verified = false;
            this.verificationState = 'consider';
            break;
          case 'declined':
          case 'false':
            this.verified = false;
            this.verificationState = 'declined';
            break;
        }
      }
    }

    public ngOnDestroy() {
      if (this.userInfo$) {
        this.userInfo$.unsubscribe();
      }
    }

    startTimer(seconds: number) {
        if (seconds === 0) {
            return;
        }
        setTimeout(() => {
            this.timer = seconds - 1;
            if (this.verified) {
                this.timer = 0;
            }
            this.startTimer(this.timer);
        }, 1000);
    }

    makeTime(time: number): string {
        time = Math.floor(time);
        let timeStr = time.toString();
        if (timeStr.length === 1) {
            timeStr = '0' + timeStr;
        }
        return timeStr;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/signup/4/signup-modal.component.ts